<template style="height: 100%;">
    <div class="CommonContentSingle-gray">
        <el-container>
            <el-header class="CommonContentSingle-header">
                <ul class="header-form">
                    <li>
                        <el-input placeholder="账号" v-model="ruleForm.UserID"></el-input>
                    </li>
                    <li>
                        <el-input placeholder="姓名" v-model="ruleForm.UserName"></el-input>
                    </li>
                </ul>
                <div class="header-Query-Option">
                    <el-button type="primary" @click="resetForm()">
                        重置
                    </el-button>
                    <el-button type="primary" @click="onSelect()">查询</el-button>
                    <el-button type="primary" @click="addUser">添加上报人员</el-button>
                </div>
            </el-header>
            <el-main>
                <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark"
                    style="width: 100%;">
                    <el-table-column label="序号" min-width="6%">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="UserID" label="账号" min-width="10%"></el-table-column>
                    <el-table-column prop="RealName" label="姓名" min-width="10%"></el-table-column>
                    <el-table-column prop="Sex" label="性别" min-width="10%"></el-table-column>
                    <el-table-column prop="Phone" label="手机" min-width="10%"></el-table-column>
                    <el-table-column prop="DeptName" label="学校名称" min-width="10%"></el-table-column>
                    <el-table-column prop="CreatedTime" label="创建时间" min-width="10%"></el-table-column>
                    <el-table-column label="操作" min-width="15%" align="center">
                        <template slot-scope="scope">
                            <span @click="dialoginfoVisible = true;
GoToReportData(scope.row)
                            " class="rp-table_btn" v-if="MenuControl == -2">
                                查看信息
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block" v-if="tableData.length > 0">
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
                        :page-size="10" layout="total, prev, pager, next" :total="RecordCount">
                    </el-pagination>
                </div>
            </el-main>
        </el-container>

        <el-dialog title="添加人员" :visible.sync="dialogVisible" :close-on-click-modal="false" width="50%">
            <div class="dialog-content" :style="{ height: dialogHeight }">
                <table>
                    <tr>
                        <th colspan="2" class="dialog-second-title">基本信息</th>
                    </tr>
                    <tr>
                        <td class="dialog-title">
                            <span class="must-tip">*</span>
                            学号
                        </td>
                        <td>
                            <el-input v-model="UserInfo.UserID" @change="GetAccountInput(UserInfo.UserID)"
                                maxlength="20"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">
                            <span class="must-tip">*</span>
                            姓名
                        </td>
                        <td>
                            <el-input v-model="UserInfo.RealName" maxlength="50"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">
                            <span class="must-tip">*</span>
                            性别
                        </td>
                        <td>
                            <el-radio v-model="UserInfo.Sex" label="1">男</el-radio>
                            <el-radio v-model="UserInfo.Sex" label="0">女</el-radio>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">
                            <span class="must-tip">*</span>
                            出生日期
                        </td>
                        <td>
                            <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                                v-model="UserInfo.Birthday" :picker-options="pickerOptions"></el-date-picker>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">
                            <span class="must-tip">*</span>
                            个人电话号码
                        </td>
                        <td>
                            <el-input v-model="UserInfo.Phone" maxlength="20"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">
                            <span class="must-tip">*</span>
                            学院
                        </td>
                        <td>
                            <el-cascader class="dialog-cascader" ref="wcascader" v-model="UserInfo.DeptID"
                                @expand-change="bumen" :options="DeptData" :props="{ checkStrictly: true }" clearable>
                            </el-cascader>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">专业</td>
                        <td>
                            <el-select v-model="UserInfo.Specialty" placeholder="请选择专业">
                                <el-option :label="item" :value="item" v-for="(item, index) in SpecialtyList"
                                    v-bind:key="index">
                                </el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">入学年份</td>
                        <td>
                            <el-select v-model="UserInfo.TheEntranceDate" placeholder="请选择入学年份">
                                <el-option :label="item" :value="item" v-for="(item, index) in YearList"
                                    v-bind:key="index"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">年级</td>
                        <td>
                            <el-select v-model="UserInfo.EntryDate" placeholder="请选择年级">
                                <el-option :label="item.CDicValue" :value="item.CDicValue"
                                    v-for="(item, index) in GradeList" v-bind:key="index"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">身份证号</td>
                        <td>
                            <el-input v-model="UserInfo.IDCard" maxlength="18"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">监护人姓名</td>
                        <td>
                            <el-input v-model="UserInfo.TheGuardian" maxlength="20"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">监护人电话号码</td>
                        <td>
                            <el-input v-model="UserInfo.TheGuardianPhone" maxlength="20"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">监护人身份</td>
                        <td>
                            <el-select v-model="UserInfo.TheGuardianRelationShip" placeholder="请选择监护人身份">
                                <el-option v-for="item in DicList[14]" :key="item.DicKey" :label="item.CDicValue"
                                    :value="item.DicKey">
                                </el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">学生类型</td>
                        <td>
                            <el-select v-model="UserInfo.Degree" placeholder="请选择学生类型">
                                <el-option :label="item.CDicValue" :value="item.CDicValue"
                                    v-for="(item, index) in DegreeList" v-bind:key="index"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">是否是贫困生</td>
                        <td>
                            <el-select v-model="UserInfo.Bak20" placeholder="请选择是否是贫困生">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">生源地</td>
                        <td>
                            <el-cascader ref="myProvinCas" v-model="UserInfo.NativePlaceList" placeholder="省/市/区"
                                :options="PlaceList" :props="{ value: 'label' }"></el-cascader>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">民族</td>
                        <td>
                            <el-select v-model="UserInfo.Nation" placeholder="请选择民族">
                                <el-option v-for="item in DicList[17]" :key="item.DicKey" :label="item.CDicValue"
                                    :value="item.DicKey">
                                </el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="dialog-title">国籍</td>
                        <td>
                            <el-select v-model="UserInfo.Nationality" placeholder="请选择国籍">
                                <el-option v-for="item in DicList[21]" :key="item.DicKey" :label="item.CDicValue"
                                    :value="item.DicKey">
                                </el-option>
                            </el-select>
                        </td>
                    </tr>
                </table>
                <div class="dialog-option">
                    <el-button type="primary" @click="submitForm">
                        保存
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { regionData } from 'element-china-area-data'

export default {
    data() {
        return {
            MenuID: '',
            MenuControl: -1,
            loading: false,
            dialogHeight: '500px',
            pageIndex: 0,
            pageSize: 10,
            RecordCount: 0,
            tableData: [],
            currentPage: 1,
            ruleForm: {
                UserID: '',
                UserName: '',
                UserTime: null,
            },
            UserInfo: {
                UserID: '',
                RealName: '',
                UserTime: null,
            },
            dialogVisible: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 3600 * 1000 * 24 + 8.64e7
                },
            },
            SpecialtyList: ['计算机科学与技术', '软件工程', '教育'],
            PlaceList: regionData,
            DicList: [],
            DegreeList: [],
            GradeList: [],
            YearList: [],
            TableConfig: {},
            DeptData: [],
        }
    },
    methods: {
        init: function (pIndex) {
            let parm = {
                PageIndex: pIndex,
                PageSize: this.pageSize,
                Account: this.ruleForm.UserID,
                Name: this.ruleForm.UserName,
            }
            this.$Http_Post('ReportCriData/GetReportDataUserList', parm)
                .then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        this.tableData = res.Data
                        this.RecordCount = Number(res.Counts)
                    } else {
                        this.Global.request_failure(res.Message)
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: 'error',
                        message: err.message,
                    })
                })
        },
        onSelect: function () {
            this.pageIndex = 0
            this.init(1)
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.init(val)
        },
        resetForm: function () {
            this.pageIndex = 0
            this.ruleForm.UserID = ''
            this.ruleForm.UserName = ''
            this.init(1)
        },
        addUser: function () {
            this.dialogVisible = true
        },
        GetAccountInput: function (uid) {
            if (uid && uid != '') {
                this.$Http_Post('ReportCriData/GetUserInfoByUserID', { UserID: uid })
                    .then((res) => {
                        if (res.Code == 200 || res.Code == 0) {
                            if (res.Data != null) this.UserInfo = res.Data
                        } else {
                            this.Global.request_failure(res.Message)
                        }
                    })
                    .catch((err) => {
                        this.$message({
                            type: 'error',
                            message: err.message,
                        })
                    })
            }
        },
        submitForm: function () {
            if (this.UserInfo.DeptID instanceof Array) {
                this.UserInfo.DeptID = this.UserInfo.DeptID[
                    this.UserInfo.DeptID.length - 1
                ]
            }
            if (this.UserInfo.UserID == '') {
                this.Global.request_info('请填写学号')
            }
            else if (this.UserInfo.RealName == '') {
                this.Global.request_info('请填写姓名')
            }
            else if (this.UserInfo.Sex == undefined || this.UserInfo.Sex == '') {
                this.Global.request_info('请选择性别')
            } else if (this.UserInfo.Birthday == undefined || this.UserInfo.Birthday == '') {
                this.Global.request_info('请填写出生日期')
            } else if (this.UserInfo.Phone == undefined || this.UserInfo.Phone == '') {
                this.Global.request_info('请填写个人电话号码')
            } else if (this.UserInfo.DeptID == undefined || this.UserInfo.DeptID == '') {
                this.Global.request_info('请选择学院')
            }
            else {
                let _this = this
                if (this.CheckSumDataState()) {
                    this.$Http_Post('ReportCriData/AddUserInfo', _this.UserInfo)
                        .then((res) => {
                            if (res.Code == 200 || res.Code == 0) {
                                this.Global.request_successful('保存成功！')
                                setTimeout((result) => {
                                    _this.dialogVisible = false
                                    _this.UserInfo = {
                                        UserID: '',
                                        RealName: '',
                                        UserTime: null,
                                    }
                                    _this.init(1)
                                }, 2000)
                            } else {
                                this.Global.request_failure(res.Message)
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: 'error',
                                message: err.message,
                            })
                        })
                }
            }
        },
        CheckSumDataState() {
            let result = true
            if (this.UserInfo.UserID == '') {
                result = false
                this.Global.request_failure('请输入学号')
            } else if (this.UserInfo.RealName == '') {
                result = false
                this.Global.request_failure('请输入姓名')
            } else if (
                this.UserInfo.Phone != undefined &&
                this.UserInfo.Phone != '' &&
                !this.Global.checkMobile(this.UserInfo.Phone)
            ) {
                result = false
                this.Global.request_failure('个人电话号码格式错误')
            } else if (
                this.UserInfo.IDCard != undefined &&
                this.UserInfo.IDCard != '' &&
                !this.Global.isCardID(this.UserInfo.IDCard)
            ) {
                result = false
                this.Global.request_failure('身份证格式错误')
            }
            return result
        },
        GoToReportData(item) {
            this.$router.push({
                path: '/ReportData/RPDataReportMaster',
                query: {
                    MenuID: this.MenuID,
                    TRPUserID: item.TRPUserID,
                    UserID: item.UserID,
                    Control: this.MenuControl
                },
            })
        },
        GetNodeByDeptID(ID, NodeList) {
            let obj = null
            for (let i = 0; i < NodeList.length; i++) {
                if (NodeList[i].DeptID == ID) {
                    obj = NodeList[i]
                    break
                } else if (
                    NodeList[i].fuzi &&
                    NodeList[i].children.length > 0 &&
                    NodeList[i].children[0].DeptID != '-1'
                ) {
                    this.GetNodeByDeptID(ID, NodeList[i].children)
                }
            }
            return obj
        },
        bumen(dt) {
            let obj = this.DeptData[0]
            for (let i = 0; i < this.DeptData.length; i++) {
                if (this.DeptData[i].DeptID == dt[dt.length - 1]) {
                    obj = this.DeptData[i]
                    break
                } else if (
                    this.DeptData[i].fuzi &&
                    this.DeptData[i].children.length > 0 &&
                    this.DeptData[i].children[0].DeptID != '-1'
                ) {
                    obj = this.GetNodeByDeptID(
                        dt[dt.length - 1],
                        this.DeptData[i].children,
                    )
                }
            }

            let _this = this
            if (
                obj.fuzi &&
                obj.children.length > 0 &&
                obj.children[0].DeptID == '-1'
            ) {
                obj.children = [{ label: '数据加载中...' }]
                this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
                    DeptID: dt[dt.length - 1],
                    content: '',
                }).then((res) => {
                    if (res.Code == 200 || res.Code == 0 && res.Data) {
                        obj.children = res.Data
                    }
                })
            }
        },
    },
    mounted() {
        this.MenuID = this.$route.query.MenuID
        this.MenuControl = this.$route.query.Control
        this.$nextTick(function () {
            this.dialogHeight =
                (document.documentElement.clientHeight * 0.65).toString() + 'px'
        })
        let _this = this
        let nowYear = new Date().getFullYear()
        for (let i = 0; i < 10; i++) {
            this.YearList.push(nowYear - i)
        }
        this.$Http_Post('User/DictionaryList')
            .then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    _this.DicList = res.Data
                } else {
                    this.Global.request_failure(res.Message)
                }
            })
            .catch((err) => {
                this.$message({
                    type: 'error',
                    message: err.message,
                })
            })
        this.$Http_Post('User/GetDicListByDicTypeCode', { "DicTypeList": 'GradeLevel,Degree' })
            .then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    _this.GradeList = res.Data[0]
                    _this.DegreeList = res.Data[1]
                } else {
                    this.Global.request_failure(res.Message)
                }
            })
            .catch((err) => {
                this.Global.request_failure(res.Message)
            })
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
            DeptID: '',
            content: '',
        }).then((res) => {
            if (res.Code == 200 || res.Code == 0 && res.Data) {
                _this.DeptData = res.Data
            }
        })
        this.init(1)
    },
}
</script>
<style>

</style>
  